module.exports = __webpack_public_path__ + "static/media/Drow.3b7246de.png";